import { post } from '@utils/api';

export class OrderSwatchesService {
  /**
   * @param {object} options
   * @param {string} options.hostlink
   * @param {string} options.productId
   * @param {object} options.payloadObj
   */
  orderSwatches = async ({ hostlink, productId, payloadObj }) => {
    const url = `${hostlink}/xapi/digital/v1/product/${productId}/orderswatches`;
    const config = { headers: { 'X-Requested-With': 'XMLHttpRequest' } };

    try {
      const response = await post(url, payloadObj, config);
      const swatchesResponse = response?.swatchesOrderCaptureResponse;

      if (swatchesResponse?.statusType === 'FAILED') {
        throw new Error(swatchesResponse?.userMessage);
      }

      if (!swatchesResponse?.statusType) {
        throw new Error('Invalid response from server');
      }

      return response?.swatchesOrderCaptureResponse;
    } catch (e) {
      /* eslint-disable no-console */
      console.error('Server error', e);
      throw new Error(e?.message);
    }
  };
}

export default OrderSwatchesService;
